export default __webpack_public_path__ + "static/media/diagram_of_phases.692a9b09.png";